"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeriveValueCell = exports.useColumns = exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const table_field_cells_1 = require("../../../components/table-field/table-field-cells");
const context_help_1 = require("../../../components/context-help/context-help");
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
const internal_settings_types_1 = require("./internal-settings-types");
exports.useStyles = makeStyles_1.default(() => ({
    columnNameWrapper: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
}));
function useColumns(collectionDataKey) {
    const intl = react_intl_1.useIntl();
    const classes = exports.useStyles();
    const deriveValueCell = useDeriveValueCell(collectionDataKey);
    const CommentCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldFactory({
        collectionDatakey: collectionDataKey,
    });
    const columns = react_1.useMemo(() => [
        {
            datakey: 'name',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__NAME',
                defaultMessage: 'Název',
            }),
            width: 200,
            CellComponent: function Cell(props) {
                var _a;
                return (react_1.default.createElement("div", { className: classes.columnNameWrapper },
                    react_1.default.createElement(table_field_cells_1.TableFieldCells.TextCell, Object.assign({}, props)),
                    react_1.default.createElement(context_help_1.ContextHelp, { label: (_a = props === null || props === void 0 ? void 0 : props.rowValue) === null || _a === void 0 ? void 0 : _a.description, type: "HOVER" })));
            },
        },
        {
            datakey: 'code',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__CODE',
                defaultMessage: 'Kód',
            }),
            width: 150,
        },
        {
            datakey: 'value',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__VALUE',
                defaultMessage: 'Hodnota',
            }),
            width: 300,
            CellComponent: function Cell(props) {
                var _a, _b;
                const DerivedCell = deriveValueCell((_b = (_a = props.rowValue) === null || _a === void 0 ? void 0 : _a.inputType) === null || _b === void 0 ? void 0 : _b.name);
                return react_1.default.createElement(DerivedCell, Object.assign({}, props));
            },
        },
        {
            datakey: 'comment',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__COMMENT',
                defaultMessage: 'Komentář',
            }),
            width: 300,
            CellComponent: CommentCell,
        },
        {
            datakey: 'updated',
            name: intl.formatMessage({
                id: 'EAS__INTERNAL_SETTINGS__COLUMN__UPDATED',
                defaultMessage: 'Datum editace',
            }),
            width: 150,
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
        },
    ], 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [deriveValueCell, intl, CommentCell]);
    return columns;
}
exports.useColumns = useColumns;
function useDeriveValueCell(collectionDataKey) {
    const TextCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineTextFieldFactory({
        collectionDatakey: collectionDataKey,
    });
    const LocalDateCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineDateFieldFactory({
        collectionDatakey: collectionDataKey,
        representation: 'local-date',
    });
    const LocalDateTimeCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineDateFieldFactory({
        collectionDatakey: collectionDataKey,
        representation: 'local-date-time',
    });
    const InstantCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineDateFieldFactory({
        collectionDatakey: collectionDataKey,
        representation: 'instant',
    });
    const NumberCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineNumberFieldFactory({
        collectionDatakey: collectionDataKey,
    });
    const CheckboxCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineCheckboxFactory({
        collectionDatakey: collectionDataKey,
    });
    return react_1.useMemo(() => function Cell(inputType) {
        switch (inputType) {
            case internal_settings_types_1.SimpleEasSettingInputType.CHECKBOX:
                return CheckboxCell;
            case internal_settings_types_1.SimpleEasSettingInputType.INTEGER:
                return NumberCell;
            case internal_settings_types_1.SimpleEasSettingInputType.DATE:
                return LocalDateCell;
            case internal_settings_types_1.SimpleEasSettingInputType.DATE_TIME:
                return LocalDateTimeCell;
            case internal_settings_types_1.SimpleEasSettingInputType.INSTANT:
                return InstantCell;
            default:
                return TextCell;
        }
    }, [
        CheckboxCell,
        TextCell,
        LocalDateCell,
        NumberCell,
        LocalDateTimeCell,
        InstantCell,
    ]);
}
exports.useDeriveValueCell = useDeriveValueCell;
//# sourceMappingURL=internal-settings-columns.js.map